import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '@/app/components/translations/Translation.tsx';
import { pinkPeople } from '@/app/components/search/styles/colors.ts';
import { BaseBadgeContainer } from '../BaseBadge/styled';

const ToLastminuteStyled = styled(BaseBadgeContainer)`
  background-color: ${pinkPeople};
  color: ${({ theme }) => theme.kallisto.color.background.static.backgroundPage};
`;

const ToLastminuteBadge = () => {
  const { t } = useTranslation();
  return <ToLastminuteStyled dangerouslySetInnerHTML={{ __html: t('vacation.oss.cards.lastminute_de_label') }} />;
};

export default ToLastminuteBadge;
